import React from 'react';

interface FormFieldProps {
  label: string;
  name: string;
  type: string;
  required?: boolean;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

const FormField: React.FC<FormFieldProps> = ({
  label,
  name,
  type,
  required = false,
  value,
  onChange,
  disabled = false
}) => {
  return (
    <div>
      <label htmlFor={name} className="block text-sm font-medium text-blue-100">
        {label} {required && '*'}
      </label>
      <input
        type={type}
        id={name}
        name={name}
        required={required}
        disabled={disabled}
        className="mt-1 block w-full rounded-xl bg-white/10 border-white/10 text-blue-100 placeholder-blue-300 focus:border-blue-400 focus:ring-blue-400 disabled:bg-white/5 disabled:text-blue-200 transition-colors duration-200"
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default FormField;